<template>
  <div class="flex block-container disp-scroll">
    <div class="table-notify">
      <div class="menu-button">
        <p>
          <b>
            <span class="mdi mdi-line" style="margin-left:5px;"></span>
            LINE公式アカウント連携設定
          </b>
        </p>
      </div>
      <p style="text-align: left; padding-left: 16px; padding-bottom: 16px;">
        LINE公式アカウントと連携することで、公式アカウントを通じて応募者にメッセージを送信することができます。
      </p>
      <p class="step">ステップ1: <a href="https://manager.line.biz/">LINE Official Account Manager</a>からMessaging APIを有効にしてください。</p>
      <p class="step">ステップ2: 表示されるChannel IDとChannel Secretを以下に入力してください。</p>
      <div class="input-field">
        <span class="input-field-label">Channel ID</span>
        <input class="input" type="text" v-model="channelId" :disabled="isLineAuthorized"/>
      </div>
      <div class="input-field">
        <span class="input-field-label">Channel Secret</span>
        <input class="input" type="text" v-model="channelSecret" :disabled="isLineAuthorized"/>
      </div>
      <p class="step">ステップ3: <a href="https://developers.line.biz/console/">LINE Developer Console</a>からWebhookの利用を有効にしてください。</p>
      <p class="step">ステップ4: 連携ボタンを押して連携を開始します。</p>
      <div class="input-field">
        <button class="button is-primary" v-if="!isLineAuthorized" @click="setChannelInfo">連携</button>
        <button class="button is-danger" v-if="isLineAuthorized" @click="deleteChannelInfo">解除</button>
        <span class="status-message">{{ statusMessage }}</span>
      </div>
      <hr>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LineApiSetting',
  data() {
    return {
      isLineAuthorized: false,
      channelId: '',
      channelSecret: '',
      statusMessage: ''
    }
  },
  mounted() {
    console.log('LineApiSetting mounted');
    this.getChannelInfo();
  },
  methods: {
    getChannelInfo() {
      this.$store.dispatch('auth/getLineChannelInfo')
      .then((res) => {
        const data = JSON.parse(res.data);
        this.isLineAuthorized = true;
        this.channelId = data['channel_id'];
        this.channelSecret = data['channel_secret'];
        this.statusMessage = "";
      }).catch((error) => {
      });
    },
    setChannelInfo() {
      this.$store.dispatch('auth/setLineChannelInfo', {
        channel_id: this.channelId,
        channel_secret: this.channelSecret
      })
      .then((res) => {
        this.isLineAuthorized = true;
        this.statusMessage = "LINE公式アカウント連携が完了しました。";
      }).catch((error) => {
        this.isLineAuthorized = false;
        this.statusMessage = "LINE公式アカウントと連携できませんでした。設定を確認してください。";
      });
    },
    deleteChannelInfo() {
      if (!confirm("LINE公式アカウント連携を解除します。今までのメッセージ履歴・応募者との連携情報は削除されます。よろしいですか？")) {
        return;
      }
      this.$store.dispatch('auth/deleteLineChannelInfo')
      .then((res) => {
        this.isLineAuthorized = false;
        this.channelId = '';
        this.channelSecret = '';
        this.statusMessage = "LINE公式アカウント連携を解除しました。";
      }).catch((error) => {
        this.statusMessage = "エラーが発生しました。";
      });
    }
  }
}
</script>

<style scoped lang="scss">
.block-container {
  height: calc(100vh - 160px);
  padding: 20px;
  width: 100%;
  flex-flow: column nowrap;
}

.table-notify {
  background: #FEFEFE;
  padding: 25px;
  border-radius: 5px;
}

.menu-button {
  display: flex;
  justify-content: space-between;
}

.input-field {
  text-align: left;
  padding-left: 32px;
  padding-top: 8px;

  .input-field-label {
    width: 160px;
    display: inline-block;
    vertical-align: middle;
  }

  .input {
    width: 300px;
    display: inline-block;
    vertical-align: middle;
  }
}

.step {
  margin: 10px 0;
  text-align: left;
  padding-left: 16px;
}

.status-message {
  vertical-align: middle;
  vertical-align: -webkit-baseline-middle;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Setting/OtherAPIs/LineApiSetting.vue